import { motion } from "framer-motion";
import { X } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";

const painPoints = [
  {
    title: "Random Workouts",
    description:
      "You train hard, but without structure, progression, and proper exercise selection, results stall fast.",
  },
  {
    title: "Confusing Nutrition",
    description:
      "Too much conflicting advice leads to inconsistency, poor recovery, and frustration.",
  },
  {
    title: "No Accountability",
    description:
      "Without expert oversight, most people lose momentum before visible progress starts.",
  },
];

export default function WhyFail() {
  const { theme } = useTheme();
  return (
    <section
      className="py-8 relative md:py-8 mb-24 bg-[var(--dvx-surface)] transition-colors duration-300 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/images/failed_trans_bg.png')" }}
    >
      {/* Overlay */}
      <div
        className={`absolute inset-0 transition-all duration-300 ${
          theme === "dark" ? "bg-black/60" : "bg-white/20"
        }`}
      ></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-[var(--dvx-primary)] font-oswald text-sm uppercase tracking-widest">
            Why People Stay Stuck
          </span>
          <h2 className="mt-4 font-oswald text-4xl md:text-5xl lg:text-6xl font-bold text-[var(--dvx-text)] uppercase tracking-tight">
            Why Most People Fail To
            <br />
            Transform Their Body
          </h2>
          <p className="mt-4 text-[white] font-manrope text-lg max-w-2xl mx-auto">
            Most people are not lazy. They are just following the wrong system.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {painPoints.map((point, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12 }}
              className="bg-[var(--dvx-bg)] border border-[var(--dvx-border)] p-8 flex flex-col gap-5"
            >
              <div className="w-10 h-10 bg-[var(--dvx-primary)]/10 border border-[var(--dvx-primary)]/30 flex items-center justify-center flex-shrink-0">
                <X size={18} className="text-[var(--dvx-primary)]" />
              </div>
              <div>
                <h3 className="font-oswald text-xl font-bold text-[var(--dvx-text)] uppercase tracking-wide mb-3">
                  {point.title}
                </h3>
                <p className="text-[var(--dvx-text-muted)] font-manrope text-sm leading-relaxed">
                  {point.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
